<app-hotkey-manager></app-hotkey-manager>
<router-outlet></router-outlet>

<app-theme-manager></app-theme-manager>
